<ng-container *ngIf="teaser">
    <ng-container *ngIf="isShown && !isClosedByUser">
        <div class="teaser-container" fxLayoutAlign="start center">
            <!-- <div (click)="openUrl()" class="rectangle">
                <ng-container *ngIf="teaserName === 'christmascalendar' else other">
                    <div class="teser-christmas"></div>
                </ng-container>
                <ng-template #other>
                    <img *ngIf="!isIconFromAssets" src="{{licenceService.getKey('icon-teaser-box')}}" class="teaser-box">
                    <img *ngIf="isIconFromAssets" src="assets/icons/{{teaser.iconName}}" />
                </ng-template>
            </div> -->

            <div style="width: 100%;cursor: pointer;" fxLayout="row" fxLayoutGap="9px" fxLayoutAlign="space-between center">
                <ng-container [ngSwitch]="teaserName">
                    <ng-container *ngSwitchCase="'firstDepositBonusLottery'">
                        <ng-container *ngTemplateOutlet="firstdepositbonus"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'activeCampaign'">
                        <ng-container *ngTemplateOutlet="activeCampaign"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'christmascalendar'">
                        <ng-container *ngTemplateOutlet="activeCampaign"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'xmasDeposit'">
                        <ng-container *ngTemplateOutlet="xmasCampaignNewUser"></ng-container>
                    </ng-container>
                    <div *ngSwitchDefault (click)="openUrl()" class="default rectangle">
                        <div class="teser-image"></div>
                        <p>{{teaser.msg}}</p>
                    </div>

                </ng-container>
                <!-- <mat-icon class="open">arrow_forward_ios</mat-icon> -->
                <!-- <mat-icon *ngIf="teaserName!=='activePromotionDisplay'" (click)="close()">close</mat-icon> -->
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #firstdepositbonus>
    <p (click)="openUrl()">{{teaser.msg}} <span class="counter">{{countDown?.minutes}}:{{countDown?.seconds}}</span></p>

</ng-template>

<ng-template #activeCampaign>
    <div (click)="scrollToCampaigns()" class="active-campaign" *ngIf="!isXmasCampaign else xmasCampaign">
        <div class="rectangle">
            <img src="{{licenceService.getKey('compaign-switch')}}">
            <p>{{teaser.msg}}</p>
        </div>
        <button round-button color="night" size="small" filled="filled" round-btn>BisON <img style="padding-left: 4px;" src="{{licenceService.getKey('campign-btn-down')}}"></button>
    </div>
</ng-template>

<ng-template #xmasCampaign>
    <div (click)="scrollToCampaigns()" class="xmas-campaign">
        <div class="rectangle">
            <!-- <img src="assets/playbison/icon-notification-on-off.png"> -->
            <div class="teser-christmas"></div>
            <p>{{teaser.msg}}</p>
        </div>
        <div class="scroll">Scroll
            <img src="assets/playbison/btn-arrow.svg" class="arrow-down">
        </div>
    </div>
</ng-template>

<ng-template #xmasCampaignNewUser>
    <div class="xmas-campaign" [routerLink]="paymentUrl">
        <div class="rectangle">
            <div class="teser-christmas-new-user"></div>
            <p i18n>Deposit and Join Bison Xmas Calender fun!</p>
        </div>
        <div class="scroll caps-text" i18n>Deposit
            <!-- <img src="assets/icons/nav-arrow-down.svg" class="arrow-down"> -->
        </div>
    </div>
</ng-template>

<ng-template #xmasCampaign>
    <div (click)="scrollToCampaigns()" class="xmas-campaign">
        <div class="rectangle">
            <div class="teser-christmas"></div>
            <p>{{teaser.msg}}</p>
        </div>
        <div class="scroll">Scroll
            <img src="assets/icons/nav-arrow-down.svg" class="arrow-down">
        </div>
    </div>
</ng-template>

<ng-template #xmasCampaignNewUser>
    <div class="xmas-campaign" [routerLink]="paymentUrl">
        <div class="rectangle">
            <div class="teser-christmas-new-user"></div>
            <p i18n>Deposit and Join Lemon Xmas Calender fun!</p>
        </div>
        <div class="scroll" i18n>Deposit
            <!-- <img src="assets/icons/nav-arrow-down.svg" class="arrow-down"> -->
        </div>
    </div>
</ng-template>

<swiper [config]="config" class="teaser-desktop-swiper" *ngIf="false">
    <ng-template swiperSlide *ngFor="let teaser of multiTeaser.teaser">
        <div class="slider-content">
            <div class="rectangle teaser-icon">
                <img src="assets/icons/{{teaser.iconName}}">
                <p>{{teaser.msg}}</p>
            </div>
            <mat-icon role="img" routerLink="{{teaser.url}}">arrow_forward_ios</mat-icon>
        </div>
    </ng-template>
</swiper>